import { render, staticRenderFns } from "./TileAdd.vue?vue&type=template&id=3b10d0b2&"
import script from "./TileAdd.vue?vue&type=script&lang=js&"
export * from "./TileAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports